import { apiClient } from '@/lib/api-client'
import type { GroceryList, GroceryListItem, GenerateGroceryListResponse, AddAdHocItemRequest, AddAdHocItemResponse } from './types'

export const groceryListService = {
  getGroceryList: (): Promise<GroceryList> =>
    apiClient.get('/api/v1/grocery-list'),

  generateGroceryList: (): Promise<GenerateGroceryListResponse> =>
    apiClient.post('/api/v1/grocery-list/generate', {}),

  tickGroceryListItem: (itemId: string, ticked: boolean): Promise<GroceryListItem> =>
    apiClient.patch(`/api/v1/grocery-list/items/${itemId}/tick`, { ticked }),

  addAdHocItem: (request: AddAdHocItemRequest): Promise<AddAdHocItemResponse> =>
    apiClient.post('/api/v1/grocery-list/items/ad-hoc', request),

  clearAlreadyGot: (): Promise<void> =>
    apiClient.delete('/api/v1/grocery-list/already-got'),
}
